import { useMediaQuery } from 'react-responsive';
import { Box, FormField, TextInput } from 'grommet';

export const Name = (): JSX.Element => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <Box
      direction={isMobile ? 'column' : 'row'}
      align="start"
      gap={isMobile ? '' : 'small'}
    >
      <FormField
        name="firstName"
        htmlFor="first-name"
        label="Name"
        width="100%"
        required
      >
        <TextInput
          id="first-name"
          name="firstName"
          placeholder="First name"
        />
      </FormField>

      <FormField
        name="lastName"
        htmlFor="last-name"
        label=""
        width="100%"
        margin={{ top: isMobile ? '6px' : '23px' }}
        required={{ indicator: false }}
      >
        <TextInput
          id="last-name"
          name="lastName"
          placeholder="Last name"
        />
      </FormField>
    </Box>
  );
};
